<template>
  <div>
    <why-wrapper></why-wrapper>
    <!-- User isn't authenticated -->
    <div v-if="!canAddActions">
      <div class="columns" v-if="!isAuthenticated && !module.isAnonymous">
        <div class="column is-6" v-if="!isAuthenticated">
          <div
            class="boxicon is-bordered has-text-centered"
            data-animation="fadeInLeft"
            style="margin-bottom: 0"
          >
            <div class="bicon">
              <a class="notlink"><b-icon icon="user-plus"></b-icon></a>
            </div>
            <h4>{{ $t('compTransitionIntroduction.box-title-1') }}</h4>
            <br />
            <div class="content">
              <p>
                <span v-html="$t('compTransitionIntroduction.box-info-6')" />
              </p>

              <ul style="list-style: none; margin-left: 1em">
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-7') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-10') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-11') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-13') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-14') }}
                </li>
              </ul>
              <br />

              <button
                class="button is-primary is-fullwidth"
                style="margin-top: 75px"
                @click="openAuthModal"
              >
                <span class="icon is-small"><i class="fa fa-user"></i></span>
                <span>{{ $t('compTransitionIntroduction.box-info-20') }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="column is-6" v-if="!module.isAnonymous">
          <div
            class="boxicon is-bordered has-text-centered"
            data-animation="fadeInLeft"
            style="margin-bottom: 0"
          >
            <div class="bicon">
              <a class="notlink"><b-icon icon="user-secret"></b-icon></a>
            </div>
            <h4>{{ $t('compTransitionIntroduction.box-title-2') }}</h4>
            <br />
            <div class="content">
              <p>
                <span v-html="$t('compTransitionIntroduction.box-info-21')" />
              </p>

              <ul style="list-style: none; margin-left: 1em">
                <li style="opacity: 0.4; color: #ff3860">
                  <span class="icon is-small"><i class="fa fa-close"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-7') }}
                </li>
                <li style="opacity: 0.4; color: #ff3860">
                  <span class="icon is-small"><i class="fa fa-close"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-10') }}
                </li>
                <li style="opacity: 0.4; color: #ff3860">
                  <span class="icon is-small"><i class="fa fa-close"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-11') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-13') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compTransitionIntroduction.box-info-14') }}
                </li>
              </ul>
              <br />

              <b-checkbox class="small" v-model="charteIsValid">
                {{ $t('compTransitionIntroduction.box-info-17') }}
                <router-link
                  class="link"
                  target="_blank"
                  to="/labos1point5-charter"
                >
                  {{ $t('compTransitionIntroduction.box-info-18') }}
                </router-link>
                {{ $t('compTransitionIntroduction.box-info-19') }}
                <em>Labos 1point5</em>.
              </b-checkbox>
              <br />
              <b-checkbox class="small" v-model="transitionCharteIsValid">
                {{
                  $t('compTransitionIntroduction.box-info-transition-charter-1')
                }}
                <router-link
                  class="link"
                  target="_blank"
                  to="/transition-1point5/charter"
                  >{{
                    $t(
                      'compTransitionIntroduction.box-info-transition-charter-2'
                    )
                  }}
                </router-link>
                {{
                  $t('compTransitionIntroduction.box-info-transition-charter-3')
                }}
                <em>Transition 1point5</em>.
              </b-checkbox>
              <br />
              <br />
              <button
                class="button is-primary is-fullwidth"
                type="submit"
                :disabled="!(charteIsValid & transitionCharteIsValid)"
                @click="$emit('is-anonymous')"
              >
                <span class="icon is-small"
                  ><i class="fa fa-arrow-circle-right"></i
                ></span>
                <span>{{ $t('compTransitionIntroduction.box-info-22') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- The user is authenticated
      We need to make sure she agrees on some general rules
    -->
      <div class="columns" v-if="isAuthenticated">
        <div class="column is-6" v-if="isAuthenticated && !module.isValid">
          <div
            class="boxicon is-bordered has-text-centered"
            data-animation="fadeInLeft"
            style="margin-bottom: 0"
          >
            <div class="bicon">
              <a class="notlink"><b-icon icon="user-plus"></b-icon></a>
            </div>
            <h4>{{ $t('compTransitionIntroduction.box-title-1') }}</h4>
            <br />

            <div class="content">
              <p>
                {{ $t('compTransitionIntroduction.box-info-26') }},
                {{ $t('compTransitionIntroduction.box-info-28') }}
              </p>
              <br />
              <form>
                <b-checkbox class="small" v-model="charteIsValid">
                  {{ $t('compTransitionIntroduction.box-info-17') }}
                  <router-link
                    class="link"
                    target="_blank"
                    to="/labos1point5-charter"
                    >{{ $t('compTransitionIntroduction.box-info-18') }}
                  </router-link>
                  {{ $t('compTransitionIntroduction.box-info-19') }}
                  <em>Labos 1point5</em>.
                </b-checkbox>
                <br />
                <b-checkbox class="small" v-model="transitionCharteIsValid">
                  {{
                    $t(
                      'compTransitionIntroduction.box-info-transition-charter-1'
                    )
                  }}
                  <router-link
                    class="link"
                    target="_blank"
                    to="/transition-1point5/charter"
                    >{{
                      $t(
                        'compTransitionIntroduction.box-info-transition-charter-2'
                      )
                    }}
                  </router-link>
                  {{
                    $t(
                      'compTransitionIntroduction.box-info-transition-charter-3'
                    )
                  }}
                  <em>Transition 1point5</em>.
                </b-checkbox>
                <br />
                <b-checkbox class="mt-10 small" v-model="confidentiality">
                  {{ $t('compTransitionIntroduction.box-info-17') }}
                  <router-link
                    class="link"
                    to="/politique-de-confidentialite"
                    target="_blank"
                  >
                    {{
                      $t('compTransitionIntroduction.box-info-23')
                    }}</router-link
                  >
                  {{ $t('compTransitionIntroduction.box-info-19') }}
                  <em>Labos 1point5</em>.
                </b-checkbox>
                <br />
                <b-checkbox class="mt-10 small" v-model="habilitation">
                  {{ $t('compTransitionIntroduction.box-info-24') }}
                  <em>Labos 1point5</em>.
                </b-checkbox>
                <br />
                <hr />
                <p>
                  {{ $t('compTransitionIntroduction.box-info-29') }}
                </p>
                <b-message :type="labInfoType" has-icon>
                  {{ $t('compTransitionIntroduction.box-info-30') }}
                </b-message>

                <b-message :type="ghgisInfoType" has-icon>
                  {{ $t('compTransitionIntroduction.box-info-31') }}
                </b-message>

                <br />
                <button
                  @click="$emit('is-valid')"
                  class="button is-primary is-fullwidth"
                  :disabled="
                    !charteIsValid ||
                    !habilitation ||
                    !confidentiality ||
                    !hasLab ||
                    !hasSubmittedGHGIs
                  "
                  type="submit"
                >
                  <span class="icon is-small"
                    ><i class="fa fa-arrow-circle-right"></i
                  ></span>
                  <span>{{
                    $t('compTransitionIntroduction.box-info-22')
                  }}</span>
                </button>
              </form>
            </div>
          </div>
        </div>
        <div class="column is-6" v-if="!module.isAnonymous">
          <div
            class="boxicon is-bordered has-text-centered"
            data-animation="fadeInLeft"
            style="margin-bottom: 0"
          >
            <div class="bicon">
              <a class="notlink"><b-icon icon="user-secret"></b-icon></a>
            </div>
            <h4>{{ $t('compTransitionIntroduction.box-title-2') }}</h4>
            <br />
            <div class="content">
              <p>
                <span v-html="$t('compTransitionIntroduction.box-info-21')" />
              </p>
              <b-checkbox class="small" v-model="charteIsValid">
                {{ $t('compTransitionIntroduction.box-info-17') }}
                <router-link
                  class="link"
                  target="_blank"
                  to="/labos1point5-charter"
                >
                  {{ $t('compTransitionIntroduction.box-info-18') }}
                </router-link>
                {{ $t('compTransitionIntroduction.box-info-19') }}
                <em>Labos 1point5</em>.
              </b-checkbox>
              <br />
              <b-checkbox class="small" v-model="transitionCharteIsValid">
                {{
                  $t('compTransitionIntroduction.box-info-transition-charter-1')
                }}
                <router-link
                  class="link"
                  target="_blank"
                  to="/transition-1point5/charter"
                  >{{
                    $t(
                      'compTransitionIntroduction.box-info-transition-charter-2'
                    )
                  }}
                </router-link>
                {{
                  $t('compTransitionIntroduction.box-info-transition-charter-3')
                }}
                <em>Transition 1point5</em>.
              </b-checkbox>
              <br />
              <br />
              <button
                class="button is-primary is-fullwidth"
                type="submit"
                :disabled="!(charteIsValid && transitionCharteIsValid)"
                @click="$emit('is-anonymous')"
              >
                <span class="icon is-small"
                  ><i class="fa fa-arrow-circle-right"></i
                ></span>
                <span>{{ $t('compTransitionIntroduction.box-info-22') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Background } from '@/mixins/background.js'

import { useAuthenticationStore } from '@/stores/authentication.js'
import { useTransitionStore } from '@/stores/transition'

export default {
  name: 'Introduction',
  props: {
    module: {
      type: Object,
      default: null
    },
    hasLab: {
      type: Boolean,
      defaut: false
    },
    hasSubmittedGHGIs: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'why-wrapper': () => import('@/components/transition/docs/WhyWrapper.vue')
  },
  mixins: [Background],
  data () {
    return {
      charteIsValid: false,
      transitionCharteIsValid: false,
      habilitation: false,
      confidentiality: false,
      displayWhy: false
    }
  },
  computed: {
    labInfoType: function () {
      return this.hasLab ? 'is-success' : 'is-danger'
    },
    ghgisInfoType: function () {
      return this.hasSubmittedGHGIs ? 'is-success' : 'is-danger'
    },
    isAuthenticated: function () {
      return this.authStore.isAuthenticated
    },
    canAddActions: function () {
      // if already add action we don't need to accept anything here
      return this.transitionStore.canAddActions
    }
  },
  methods: {
    openAuthModal () {
      this.authStore.openAuthModal('/administration/transition-maps')
    }
  },
  setup () {
    const authStore = useAuthenticationStore()
    const transitionStore = useTransitionStore()
    return { authStore, transitionStore }
  },
  mounted () {
    // populate the store to check the access needs
    this.transitionStore.init()
  }
}
</script>

<style lang="css" scoped>
.boxicon .content {
  text-align: justify !important;
}
</style>
